
//import { animate } from '@angular/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule, Router } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from "@angular/common";


import { MaterialModuleModule } from './material-module/material-module.module';
// import { MatToolbarModule } from "@angular/material/toolbar";
// import { MatSidenavModule } from "@angular/material/sidenav";
// import { MatListModule } from "@angular/material/list";
// import { MatButtonModule } from "@angular/material/button";
// import { MatCardModule } from "@angular/material/card";
// import { MatIconModule } from "@angular/material/icon";
// import {MatRippleModule, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material/core';
// import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatInputModule } from '@angular/material/input';
// import {MatSnackBarModule} from '@angular/material/snack-bar';
// import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
// import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
// import {MatSelectModule} from '@angular/material/select';
// import {MatDatepickerModule} from '@angular/material/datepicker';
// import {MatNativeDateModule} from '@angular/material/core';
// import {MatTabsModule} from '@angular/material/tabs';
// import {MatStepperModule} from '@angular/material/stepper';
// import {MatSortModule} from '@angular/material/sort';
// import {MatDialogModule} from '@angular/material/dialog';
// import {MatTableModule} from '@angular/material/table';
//import { MatMomentDateModule } from "@angular/material/core";
//import {MatMomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

// import {MatButtonToggleModule} from '@angular/material/button-toggle';
// import {MatRadioModule} from '@angular/material/radio';
// import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {ClipboardModule} from '@angular/cdk/clipboard';


import { FlexLayoutModule } from '@angular/flex-layout';
//import { CarouselComponent } from './pages';
import { MatCarouselModule } from '@ngmodule/material-carousel';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';

//import { NgScrollbarModule } from 'ngx-scrollbar';
//import { SmoothScrollModule } from 'ngx-scrollbar/smooth-scroll';
//import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
//import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
//import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { LazyLoadImageModule } from 'ng-lazyload-image';

//import { NgxTweetModule } from "ngx-tweet";

import { FacebookModule } from 'ngx-facebook';

// import { NguCarouselModule } from '@ngu/carousel';

import { SharedModule } from './shared-module/shared.module';

import { AppComponent } from './app.component';
//import { NavbarComponent } from './@theme/components/';
//import { StudentBranchesComponent } from './student-branches/student-branches.component';
//import { EventsComponent } from './events/events.component';
//import { EventComponent } from './event/event.component';
//import { AboutComponent } from './about/about.component';
import { BottomBarComponent } from './@theme/bottom-bar/bottom-bar.component';
import { TestComponent } from './test/test.component';
//import { NewsletterComponent } from './newsletter/newsletter.component';
//import { ContactUsPageComponent } from './contact-us-page/contact-us-page.component';
//import { HomeComponent } from './home/home.component';
//import { StudentBranchesPageComponent } from './student-branches-page/student-branches-page.component';
//import { BlogComponent } from './blog/blog.component';
//import { ArticleComponent } from './article/article.component';
//import { StudentBranchDetailsComponent } from './student-branch-details/student-branch-details.component';
//import { InfoSlideshowComponent } from './info-slideshow/info-slideshow.component';
//import { LoadingComponent } from './loading/loading.component';
//import { SignUpComponent } from './sign-up/sign-up.component';
//import { ShareBottomsheetComponent } from './share-bottomsheet/share-bottomsheet.component';
//import { MembershipFormComponent } from './membership-form/membership-form.component';
//import { ContactInformationComponent } from './membership-form/contact-information.component';
//import { ProfessionalFormComponent } from './membership-form/professional-form.component';
//import { WhyJoiningComponent } from './membership-form/why-joining.component';
//import { AboutPageComponent } from './about-page/about-page.component';
//import { PaymentPageComponent } from './payment-page/payment-page.component';
//import { EventsListPageComponent } from './events-list-page/events-list-page.component';
//import { DialogComponent } from './@theme/components/dialog/dialog.component';
//import { SvgIconComponent } from './@theme/components/svg-icon/svg-icon.component';

//import { ScrollSpyDirective } from './scroll-spy.directive';

//import { SanitizeHtmlPipe } from './@core/pipes/sanitize-html.pipe';





// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true
// };

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@NgModule({
  declarations: [
    AppComponent,
    // NavbarComponent,
    // CarouselComponent,
    // StudentBranchesComponent,
    // EventsComponent,
    // EventComponent,
    // AboutComponent,
     BottomBarComponent,
    TestComponent,
    // NewsletterComponent,
    // ContactUsPageComponent,
    // HomeComponent,
    // StudentBranchesPageComponent,
    // BlogComponent,
    // ArticleComponent,
    // StudentBranchDetailsComponent,
    // SvgIconComponent,
    // ScrollSpyDirective,
    // InfoSlideshowComponent,
    // LoadingComponent,
    // SignUpComponent,
    // ShareBottomsheetComponent,
    // MembershipFormComponent,
    // ContactInformationComponent,
    // ProfessionalFormComponent,
    // WhyJoiningComponent,
    // AboutPageComponent,
    // PaymentPageComponent,
    //SanitizeHtmlPipe,
    // EventsListPageComponent,
    //DialogComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    CommonModule,
    MaterialModuleModule,
    SharedModule,
    FacebookModule.forRoot(),
    // MatToolbarModule,
    // MatSidenavModule,
    // MatListModule,
    // MatIconModule,
    // MatButtonModule,
    // MatCardModule,
    // MatRippleModule,
    // MatFormFieldModule,
    // MatInputModule,
    // MatSnackBarModule,
    // MatProgressSpinnerModule,
    // MatBottomSheetModule,
    // MatSelectModule,
    // MatDatepickerModule,
    // //MatMomentDateModule,
    // MatNativeDateModule,
    // MatStepperModule,
    // MatButtonToggleModule,
    // MatTabsModule,
    // MatTableModule,
    // MatSortModule,
    // MatRadioModule,
    // MatDialogModule,
     ClipboardModule,
    // MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatCarouselModule.forRoot(),
    // NgScrollbarModule,
    // SmoothScrollModule,
    // PerfectScrollbarModule,
    LazyLoadImageModule,
    //NguCarouselModule,
    //LeafletModule,
    //NgxTweetModule
  ],
  entryComponents: [
    //DialogComponent
  ],
  providers: [
    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    // },
    
   
    
    // {
    //   provide: DateAdapter,
    //   useClass: MomentDateAdapter,
    //   deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    // },
  
      // {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
